<template>
    <div class="card">
        <div class="print-preview">
            <logo-horizontal></logo-horizontal>
            <div class="print-btn-top"
                style="display:none">
                <md-button class="md-raised md-primary"
                    @click="printReport">
                    <md-icon>print</md-icon>
                    {{ $t('general.print') }}
                </md-button>
            </div>
        </div>
        <div v-if="reportDataSource.length > 0">
            <table v-for="(product, index) in reportDataSource"
                :key="index"
                class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col"
                            style="width:18%">
                            {{ $t('general.total') }}
                        </th>
                        <th scope="col"
                            style="width:20%">
                            {{ $tc('units.unit', 1) }}
                        </th>
                        <th scope="col"
                            style="width:18%">
                            {{ $t('products.product-name') }}
                        </th>
                        <th scope="col"
                            style="width:19%">
                            {{ $tc('calibers.caliber', 1) }}
                        </th>
                        <th scope="col"
                            style="width:19%">
                            {{ $t('orders.fish-status') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <span>
                                {{ product.total }}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{ product.unit_name }}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{ product.product_name }}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{ product.caliber_name }}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{ product.state_name }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6"
                            style="padding:0 2.5%">
                            <table class="table table-condensed table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col"
                                            style="width:12%">
                                            {{ $tc('orders.order',1) }}
                                        </th>
                                        <th scope="col"
                                            style="width:12%">
                                            {{ $tc('organizations.organization',1) }}
                                        </th>
                                        <th scope="col"
                                            style="width:12%">
                                            {{ $t('orders.delivery-date') }}
                                        </th>
                                        <th scope="col"
                                            style="width:10%">
                                            {{ $t('orders.order-status') }}
                                        </th>
                                        <th scope="col"
                                            style="width:10%">
                                            {{ $tc('products.quantity',1) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(order, orderIndex) in product.orders"
                                        :key="orderIndex">
                                        <td>
                                            <span>
                                                {{ order.order_id }}
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                {{ order.organization_name }}</span>
                                        </td>
                                        <td>
                                            <span>
                                                {{ formatDateTime(order.delivery_date) }}
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                {{ order.description }}
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                {{ order.quantity }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="print-preview">
            <div class="print-btn-bottom">
                <md-button class="md-raised md-primary"
                    @click="printReport">
                    <md-icon>print</md-icon>
                    {{ $t('general.print') }}
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import LogoHorizontal from '@/components/ui/LogoHorizontal.vue'
import luxon from '@/mixins/luxon'
import { mapGetters } from 'vuex'

export default {
    name: 'OrdersReportPreview',

    mixins: [luxon],

    components: {
        LogoHorizontal
    },

    data () {
        return {
            reportDataSource: []
        }
    },

    computed: {
        ...mapGetters([
            'printPreview'
        ])
    },

    methods: {
        printReport () {
            window.print()
        }
    },

    async created () {
        let self = this
        self.reportDataSource = this.$store.getters.printPreview
    }
}
</script>
